import type { CSSProperties } from 'react';

/**
 * Anel do avatar do contato na cor do canal: verde WhatsApp; rosa Instagram
 * (API oficial ou parceiro WAME). Fonte única — lista de atendimentos,
 * cabeçalho da conversa e detalhe do contato usam o mesmo, pra não divergirem.
 *
 * Anel fino de 1px afastado 1px do avatar (rebrand, out/2026). Usa `outline`
 * em vez de box-shadow pra o respiro ficar transparente: mostra o fundo real
 * do card (branco, azul do selecionado, cinza do hover) sem halo branco.
 */
export function anelDoAvatar(instagram: boolean): CSSProperties {
  return {
    outline: `1px solid ${instagram ? '#DD2A7B' : 'var(--wa-500)'}`,
    outlineOffset: '1px',
  };
}
